Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.tickLabels = exports.baseTickLabel = exports.baseLabel = undefined;

var _svgFont = require('./svgFont');

var _svgFont2 = _interopRequireDefault(_svgFont);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var baseLabel = exports.baseLabel = Object.assign({}, _svgFont2['default'].small, _svgFont2['default'].bold, _svgFont2['default'].middle, {
  pointerEvents: 'none'
});

var baseTickLabel = exports.baseTickLabel = Object.assign({}, _svgFont2['default'].small, _svgFont2['default'].light, _svgFont2['default'].middle, {
  pointerEvents: 'none'
});

var tickLabels = exports.tickLabels = {
  top: Object.assign({}, baseTickLabel, {
    dy: '-0.25em'
  }),
  right: Object.assign({}, baseTickLabel, _svgFont2['default'].start, {
    dx: '0.25em',
    dy: '0.25em'
  }),
  bottom: Object.assign({}, baseTickLabel, {
    dy: '0.25em'
  }),
  left: Object.assign({}, baseTickLabel, _svgFont2['default'].end, {
    dx: '-0.25em',
    dy: '0.25em'
  })
};

exports['default'] = {
  baseLabel: baseLabel,
  baseTickLabel: baseTickLabel,
  tickLabels: tickLabels
};